import { VideoPlayer, SubsectionTitle } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: [LAYOUT_SPACING.MEDIUM, LAYOUT_SPACING.MEDIUM, LAYOUT_SPACING.LARGE],
})``

const Title = styled(SubsectionTitle)``

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const Video = ({ introTitle, introAst, video }) => (
  <Layout>
    {introTitle && <Title>{introTitle}</Title>}
    <CopyRenderer htmlAst={introAst} />
    <VideoPlayer {...video} />
  </Layout>
)

Video.propTypes = {
  introTitle: PropTypes.string,
  introAst: PropTypes.object.isRequired,
  video: PropTypes.object.isRequired,
}

Video.defaultProps = {
  introTitle: ``,
}

export default Video
